import classNames from 'clsx'
import { bool, shape } from 'prop-types'

import { omit } from 'shared/utils/objectUtils'
import ProductVariantCompactFollowUpLink from 'views/components/organisms/ProductVariantsCompact/ProductVariantCompact/ProductVariantCompactFollowUpLink'
import withShopAndRuntimeConfig from 'views/enhancers/withShopAndRuntimeConfig'
import { getDiscountToShow } from 'views/utils/discount'
import { isDiscountValid } from 'views/utils/productUtils'
import {
  ProductVariantType,
  publicRuntimeConfigType,
} from 'views/utils/propTypes'
import { isRequired } from 'views/utils/propTypeUtils'

const ProductVariantCompactDetails = ({
  variant: { followUpProductCode, unitQuantityString, unit, discount },
  isNotAvailable,
  publicRuntimeConfig: {
    publicConfig: { discountBoundaries, tenant },
  },
}) => {
  const label = `${unitQuantityString} ${unit}`
  const labelClassName = classNames(
    'm-ProductVariant__checkbox l-flex__primary',
    {
      'm-ProductVariant--disabled u-color--grey': isNotAvailable,
    }
  )
  const discountsToShow = getDiscountToShow({ tenant, discount })
  const discountBlock =
    !isNotAvailable &&
    isDiscountValid(discount, discountBoundaries) &&
    discountsToShow ? (
      <div className="m-ProductVariant__discount a-h5 u-no-margin">
        <span>-{discount}%</span>
      </div>
    ) : null

  const hasFollowUpLink = Boolean(isNotAvailable && followUpProductCode)

  return (
    <>
      <div className={labelClassName}>
        <div className="u-no-margin a-h5">{label}</div>
      </div>
      {discountBlock}
      {hasFollowUpLink && (
        <ProductVariantCompactFollowUpLink
          followUpProductCode={followUpProductCode}
        />
      )}
    </>
  )
}

ProductVariantCompactDetails.propTypes = {
  variant: shape(isRequired(omit(ProductVariantType, ['followUpProductCode'])))
    .isRequired,
  isNotAvailable: bool.isRequired,
  publicRuntimeConfig: shape(publicRuntimeConfigType).isRequired,
}

export default withShopAndRuntimeConfig(ProductVariantCompactDetails)
